import React, { useEffect, useState } from 'react';
import { fetchRealTimeEfficiency } from '../../../Service/APIService';
import Auth from '../../../shared/Auth';
import TableHeader from '../../Custom/TableHeader';
import ChartLoader from '../../Loaders/ChartLoader';

const ChartRealTimeEfficience = ({ type, id }) => {
  const [isLoading, setLoading] = useState(true);
  const [efficiency, setEfficiency] = useState(0);

  useEffect(() => {
    async function fetchData() {
      const checkToken = await Auth();
      if (checkToken) {
        setLoading(true);
        fetchRealTimeEfficiency(type, id)
          .then((response) => {
            const { statusCode, result } = response.data;
            setEfficiency(statusCode === 200 ? result.efficiency : 0);
          })
          .finally(setLoading(false));
      }
    }
    fetchData();
  }, [type, id]);

  if (isLoading) {
    return <ChartLoader height="150" width="600" />;
  }
  return (
    <TableHeader title={'Real Time Efficiency'}>
      <span
        style={{
          textAlign: 'center',
          fontSize: '38px',
          fontWeight: '300',
          width: '100%',
        }}
      >
        {efficiency} %
      </span>
    </TableHeader>
  );
};
export default ChartRealTimeEfficience;
